import {Action} from '@ngrx/store';
import {type} from '../../shared/utilities/type';
import {CommonField} from '../../shared/models/common-field';

export const licencesActionTypes = {
  LOAD: type('[Licences] Load'),
  LOAD_SUCCESS: type('[Licences] Load Success'),
  LOAD_FAIL: type('[Licences] Load Error')
};

export class LoadLicencesAction implements Action {
  readonly type = licencesActionTypes.LOAD;
  constructor() {}
}

export class LoadLicencesSuccessAction implements Action {
  readonly type = licencesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: CommonField[]) {}
}

export class LoadLicencesFailAction implements Action {
  readonly type = licencesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
